// Bridge: re-export the task form implementation from `src/projects/pages`
import TaskFormPage from "../projects/pages/TaskFormPage";

export default TaskFormPage;
